import BaseService from "../baseService";
class Logins extends BaseService {
    constructor(id) {
        const resource = "login";
        let relationship = {};
        super(id, relationship, resource);
    }
}

export default (id) => new Logins(id);
